import { CampaignActionsDialogsProvider } from './CampaignActionsDialogs/CampaignActionsDialogsProvider'
import { CampaignsTable } from './CampaignsTable/CampaignsTable'
import { useCampaignsTable } from './useCampaignsTable'

export function CampaignsTab() {
  const [{ data, isLoading, errorMessage, totalResults }, { nextPage, previousPage, refresh }] = useCampaignsTable()

  return (
    <CampaignActionsDialogsProvider refresh={refresh}>
      <CampaignsTable
        data={data ?? []}
        isLoading={isLoading}
        errorMessage={errorMessage}
        totalResults={totalResults}
        nextPage={nextPage}
        previousPage={previousPage}
      />
    </CampaignActionsDialogsProvider>
  )
}
